const gtmTrace = {
	addToCart: function (data) {
		dataLayer.push({
			event: "addToCart",
			ecommerce: {
				currencyCode: "TWD",
				add: {
					products: [
						{
							name: typeof htmlDecode !== "undefined" ? htmlDecode(data.name) : data.name,
							id: data.id,
							price: data.price,
							brand: "",
							category: "",
							variant: data.color,
							quantity: data.count,
						},
					],
				},
			},
		});
	},
	removeFromCart: function (data) {
		dataLayer.push({
			event: "removeFromCart",
			ecommerce: {
				remove: {
					products: [
						{
							name: typeof htmlDecode !== "undefined" ? htmlDecode(data.name) : data.name,
							id: data.id,
							price: data.price,
							brand: "",
							category: "",
							variant: data.color,
							quantity: data.count,
						},
					],
				},
			},
		});
	},
};

export default gtmTrace;
